export const defaultPaidMediaObjectives = [
  { name: 'Reconhecimento de marca' },
  { name: 'Alcance' },
  { name: 'Tráfego' },
  { name: 'Engajamento' },
  { name: 'Visualizações de vídeo/conteúdo' },
  { name: 'Geração de leads' },
  { name: 'Mensagens e interação direta' },
  { name: 'Instalações de aplicativos' },
  { name: 'Conversões no site/app' },
  { name: 'Vendas (online/offline)' },
  { name: 'Visitas à loja' },
];
